import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Typography } from '@material-ui/core';
import React from 'react';
import { QuestionTheme } from '../../styles/mfsTheme';
import { OpenQuestionStyles } from '../../styles/openQuestion';
import { useTranslation } from 'react-i18next';
import { DEBOUNCING_DELAY } from '../../constants/shl360';
let typingTimer: NodeJS.Timeout;

interface TextAreaProps {
  cls: string;
  charLimit: number;
  showError?: boolean;
  questionSequence?: number | string;
  selectedResponse?: string;
  value: string;
  itemId?: number;
  nextButtonRef: React.RefObject<HTMLButtonElement>;
  backButtonRef: React.RefObject<HTMLButtonElement>;
  onValueChange: (value: string, id?: string) => void;
}

const TextArea = ({
  cls,
  charLimit,
  onValueChange,
  showError,
  value,
  nextButtonRef,
  backButtonRef,
}: TextAreaProps): JSX.Element => {
  const classes = OpenQuestionStyles(QuestionTheme);
  const { t } = useTranslation();
  const [val, setVal] = React.useState(value);
  const textRef = React.useRef<HTMLTextAreaElement>(null);

  /** input field change/Blur Event handler */
  const onChange = (event: React.ChangeEvent): void => {
    if (nextButtonRef.current && backButtonRef.current) {
      nextButtonRef.current.style.pointerEvents = 'none';
      backButtonRef.current.style.pointerEvents = 'none';
    }
    const value = (event.target as HTMLTextAreaElement).value;
    const id =
      (event.target.parentNode as HTMLElement).dataset.tempid ||
      (event.target.parentNode as HTMLElement).getAttribute('data-tempid') ||
      '0';
    setVal(value);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      onValueChange(value, id.toString());
      if (nextButtonRef.current && backButtonRef.current) {
        nextButtonRef.current.style.pointerEvents = 'all';
        backButtonRef.current.style.pointerEvents = 'all';
      }
    }, DEBOUNCING_DELAY);
  };

  React.useEffect(() => {
    return (): void => clearTimeout(typingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TextareaAutosize
        ref={textRef}
        id="comment"
        name="comment"
        maxLength={charLimit}
        className={`${cls} ${showError && classes.error}`}
        value={val || ''}
        aria-label={t('comments')}
        onChange={onChange}
      />
      <Typography
        className={classes.charCount}
        aria-label={`${val ? val.trim().length : 0} / ${charLimit}`}
        aria-required="true">
        {`${val ? val.trim().length : 0}/${charLimit}`}
      </Typography>
    </>
  );
};

export default TextArea;
